import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../fragments/button';
import Dialog from '../../../fragments/dialog';

import {
  fetchGenBankFeatureSample,
  fetchGenbankGIID,
} from '../../../../utils/sequence-helper';

import style from './style.css';


export default class GenbankSample extends React.Component {

  static propTypes = {
    rawDataCollection: PropTypes.object.isRequired,
  };

  constructor() {
    super(...arguments);
    this.state = {
      showDialog: false,
      gbXMLSample: null,
      giID: null,
      gbFileSample: null,
    };
  }

  async componentDidMount() {
    const {rawDataCollection} = this.props;
    if (rawDataCollection.loadFrom !== 'Genbank') {
      return;
    }
    const {accession} = this;
    if (!accession) {
      return;
    }
    await this.handleLoadgiID();
    // await this.handleLoadXMLSample();
    await this.handleLoadFileSample();
  }

  get accession() {
    const {rawDataCollection} = this.props;
    const {sequenceType, rawSequences} = rawDataCollection;

    if (sequenceType !== 'complete') {
      return null;
    }

    if (!rawSequences || rawSequences.length == 0) {
      return null;
    }

    const {accessions} = rawDataCollection;

    if (!accessions || accessions.length == 0) {
      return null;
    }

    return accessions[0];
  }

  async handleLoadgiID() {
    const {accession} = this;
    const giID = await fetchGenbankGIID(accession);
    this.setState({
      giID,
    });
  }

  async handleLoadXMLSample() {
    const {accession} = this;

    const gbXMLSample = await fetchGenBankFeatureSample(accession);
    this.setState({
      gbXMLSample,
    });
  }

  async handleLoadFileSample() {
    const {gbFileURL} = this;
    const resp = await fetch(gbFileURL);
    const gbFileSample = await resp.text();

    this.setState({
      gbFileSample
    });
  }

  get gbFileURL() {
    const {giID} = this.state;

    return (
      'https://www.ncbi.nlm.nih.gov/sviewer/viewer.cgi' +
      '?tool=portal&save=open&log$=seqview&db=nuccore&report=genbank&' +
      'id=' + giID + '&conwithfeat=on&withparts=on&hide-cdd=on'
    );
    // return `https://www.ncbi.nlm.nih.gov/nucleotide/${accession}`;
  }

  get shouldShow() {

    const {accession} = this;
    if (!accession) {
      return false;
    }

    const {gbFileSample} = this.state;
    if (!gbFileSample) {
      return false;
    }

    // const {gbXMLSample} = this.state;
    // if (!gbXMLSample) {
    //   return false;
    // }

    return true;
  }

  handleOpen() {
    this.setState({
      showDialog: true
    });
  }

  handleClose() {
    this.setState({
      showDialog: false
    });
  }

  get sample_dialog() {
    const {showDialog} = this.state;
    if (!showDialog) {
      return null;
    }

    const {gbFileSample} = this.state;
    return (
      <Dialog
       width="42rem"
       onClose={
         this.handleClose.bind(this)
       }
       closeOnBlur={false}>
        <pre className={style.pre}>
          {gbFileSample}
        </pre>
      </Dialog>
    );
  }

  render() {
    const {shouldShow} = this;
    if (!shouldShow) {
      return null;
    }

    const {sample_dialog} = this;

    return (
      <div className={style.genbank}>
        <Button
         onClick={
          this.handleOpen.bind(this)}>
           View Genbank annotation
        </Button>
        {sample_dialog}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/genbank/genbank-sample.js